import { Rescatable } from '../Rescatable';
import { order } from '../decorators/order';
import { imagenPathS3 } from '../decorators/imagenPathS3';
import { Subcategory } from './Subcategory';

export class SubcategoryBanner extends Rescatable {
  static _name = 'SubcategoryBanner';
  static pathRequest = Rescatable.pathRequestStatic + 'espacios/subcategorias';
  static pk: keyof SubcategoryBanner = 'id';
  id: number;
  estado: boolean;
  @imagenPathS3('/bannerSubcategoria')
  nombre: string;
  @imagenPathS3('/bannerSubcategoria')
  nombreTablet: string;
  @imagenPathS3('/bannerSubcategoria')
  nombreMobile: string;
  @order()
  idSubCate: number;
  $subcatgories?: Subcategory[];
  fechaVencimiento: string;
  fechaLanzamiento: string;
}
